export interface Booking {
  id: number;
  bookingDate: string | Date;
  documentNumber1: string | null,
  documentNumber2: null | string,
  documentDate: Date | string,
  account: string,
  contraAccount: string,
  transactionKey: string,
  debitCredit: string,
  amount: number;
  currency: string,
  exchangeRate: string,
  description: string;
  costCenter1: string,
  costCenter2: string,
  createdAt: string;
  updatedAt?: string;
  additionalInfo: string,
}

export enum BookingStatus {
  ASSIGNED = 'ASSIGNED',
  UNASSIGNED = 'UNASSIGNED',
  REVIEWED = 'REVIEWED',
}
